import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Dropdown, SkeletonTaskCard } from "../indexComponents";

function TaskCard({ task, refreshTasks, isTeam, clients, isLoading }) {
  const [isPopupDisplayed, setIsPopupDisplayed] = useState(false);
  const navigate = useNavigate();
  const [clientName, setClientName] = useState(null);
  const [stepsToShow, setStepsToShow] = useState([""]);
  const [showDots, setShowDots] = useState([""]);
  const [statue, setStatue] = useState("");

  const options = [
    { value: "Active", label: "Active" },
    { value: "En cours", label: "En cours" },
    { value: "Terminé", label: "Terminé" },
  ];

  const handleStatueChange = (selectedOption) => {
    setStatue(selectedOption ? selectedOption.value : null);
    saveStatue(selectedOption ? selectedOption.value : null);
  };

  const saveStatue = async (newStatue) => {
    const statueUpdated = newStatue;
    console.log("statue", statueUpdated);
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/tasks/${task.id}/${isTeam}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          name: task.name,
          steps: task.steps,
          statue: statueUpdated,
        }),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to update task");
    }
    refreshTasks();
  };

  useEffect(() => {
    if (task && Object.keys(task).length) {
      const uncompletedStepsArray = task.steps.filter(
        (step) => !step.completed
      );
      setStepsToShow(
        uncompletedStepsArray && uncompletedStepsArray.slice(0, 3)
      );
      setShowDots(uncompletedStepsArray && uncompletedStepsArray.length > 3);

      if (clients) {
        const client = clients.find((client) => client.id === task.clientId);
        const clientName = client ? client.name : "";
        setClientName(clientName);
      }
    }
  }, [task, clients]);

  const handleClick = () => {
    if (isTeam) {
      navigate(`/tasks/${task.id}/${isTeam}`);
    } else {
      navigate(`/tasks/${task.id}/${isTeam}`);
    }
  };

  const handleDelete = async () => {
    if (isTeam) {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/team-tasks-delete/${task.id}`,
          {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to delete task");
        }

        refreshTasks();
      } catch (error) {
        console.error("Error deleting task:", error);
      }
    } else {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/tasks/${task.id}`,
          {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to delete task");
        }

        refreshTasks();
        console.log("Task deleted:", task.id);
      } catch (error) {
        console.error("Error deleting task:", error);
      }
    }
  };

  const calculateProgressPercentage = () => {
    if (!Array.isArray(task.steps)) {
      return 0;
    }

    const totalSteps = task.steps.length;
    const completedSteps = task.steps.filter((step) => step.completed).length;

    return Math.round((completedSteps / totalSteps) * 100);
  };

  return (
    <div className="TaskCard-frame">
      {!isLoading && Object.keys(task).length ? (
        <>
          <div
            className={`TaskCard ${
              task.statue === "Terminé" ? "finished" : ""
            }`}
            onClick={handleClick}
          >
            <div className="TaskCard-content">
              {isTeam ? <h2>{task.Team ? task.Team.name : ""}</h2> : ""}
              {isTeam ? (
                <p className="assignTo">
                  Assigné à{" "}
                  {task.assignTo[0].includes("Tous les membres")
                    ? "Tous les membres"
                    : task.assignTo.join(" ")}
                </p>
              ) : null}
              <h2>{task.name}</h2>
              <p className="client-name">
                {isTeam ? clientName : task.Client.name}
              </p>
              <ul>
                {Array.isArray(stepsToShow) &&
                  stepsToShow.map((step, index) => (
                    <li className="step" key={index}>
                      - {step.content}
                    </li>
                  ))}
              </ul>
              {showDots && <li>. . .</li>}
            </div>
            <div className="progress-bar">
              <div
                className="progress-bar__completed"
                style={{ width: `${calculateProgressPercentage()}%` }}
              ></div>
            </div>
            <p className="progress-pourcentage">
              Terminé à {calculateProgressPercentage()}%
            </p>
            <p
              className={`task-status ${
                task.statue === "Active"
                  ? "active"
                  : task.statue === "En cours"
                  ? "in-progress"
                  : "done"
              }`}
            >
              <span className="white">Statue :</span> {task.statue}
            </p>
          </div>
        </>
      ) : (
        <SkeletonTaskCard />
      )}

      {isPopupDisplayed ? (
        <div className="popup-frame">
          <div className="popup-content">
            <h2>Voulez-vous vraiment supprimer cette tâche ?</h2>
            <div className="btn-container">
              <button
                className="supprimer"
                onClick={(e) => (setIsPopupDisplayed(false), handleDelete())}
              >
                Supprimer
              </button>
              <button
                className="annuler"
                onClick={(e) => setIsPopupDisplayed(false)}
              >
                Annuler
              </button>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}

      <div className="btn-container">
        <button
          className="btn-supprimer"
          onClick={(e) => setIsPopupDisplayed(true)}
        >
          Supprimer
        </button>
        <Dropdown
          options={options}
          placeholder="Définir comme"
          onChange={handleStatueChange}
          value={statue.value}
        />
      </div>
    </div>
  );
}

export default TaskCard;
